/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditortitlelabel3Inputs */

const en_menueditortitlelabel3 = /** @type {(inputs: Menueditortitlelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const de_menueditortitlelabel3 = /** @type {(inputs: Menueditortitlelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel`)
};

/**
* | output |
* | --- |
* | "Title" |
*
* @param {Menueditortitlelabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditortitlelabel3 = /** @type {((inputs?: Menueditortitlelabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditortitlelabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditortitlelabel3(inputs)
	return de_menueditortitlelabel3(inputs)
});
export { menueditortitlelabel3 as "menuEditorTitleLabel" }